import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

export default class slab_Masonry {
    constructor() {

        this.init();
        
    }

    init() {

        // === MASONRY ===
        const grid = document.querySelector('.masonry');
        if( grid ) {
            imagesLoaded(grid, function() {
                const msnry = new Masonry(grid, {
                    itemSelector: '.masonry-item',
                    columnWidth: '.masonry-sizer',
                    percentPosition: true,
                    horizontalOrder: true
                });
            });
        }

    }
}